module.exports = __webpack_public_path__ + "static/img/mobile_home_cpjfw_znsb.ae9ef06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_cpjfw_znsb.png
// module id = RXpg
// module chunks = 21